/**
 * Vocabulary shared by every entity (audit, intervention, appointment, customize).
 * Constants owned by a single sub-entity belong to its own `constants.js`.
 */

export const PENDING_SIGNATURE_STORAGE_KEY = 'pendingSignatureEntityId';

const SALES_OFFERS_CHECKLIST_TYPES = {
  VEHICLE: 'VEHICLE',
  ACCESSORY: 'ACCESSORY',
  TRADE_IN: 'TRADE_IN',
  DISCOUNT: 'DISCOUNT',
};

export const CHECKLIST_TYPE = {
  WORK: 'WORK',
  DONE: 'DONE',
  SCHEDULED: 'SCHEDULED',
  REMINDER_SCHEDULED: 'REMINDER_SCHEDULED',
  CONTROLS: 'CONTROLS', // Control report
  BILLING: 'BILLING',
  ISSUES: 'ISSUES',
  DOCUMENTS: 'DOCUMENTS',
  UPSELLING: 'UPSELLING',
  PARTS: 'PARTS',
  PARTS_REMINDER_SCHEDULED: 'PARTS_REMINDER_SCHEDULED',
  ...SALES_OFFERS_CHECKLIST_TYPES,
};

export const DEFAULT_ACCEPTED_CHECKLIST_TYPES = [
  CHECKLIST_TYPE.DONE,
  CHECKLIST_TYPE.UPSELLING,
  CHECKLIST_TYPE.DISCOUNT,
];

export const SEVERITY = {
  UNDEFINED: 'UNDEFINED',
  NONE: 'NONE',
  LOW: 'LOW',
  HIGH: 'HIGH',
  OFFERED: 'OFFERED',
  PROPOSED: 'PROPOSED',
};

export const UNHANDLED_SEVERITIES = [SEVERITY.OFFERED, SEVERITY.NONE, SEVERITY.UNDEFINED];

export const MODE = {
  PARTS: 'PARTS',
  SALES: 'SALES',
  TECHNICIAN: 'TECHNICIAN',
  AUDIT: 'AUDIT',
};

export const ADVICE_STATUS = {
  ACCEPTED: 'ACCEPTED',
  REFUSED: 'REFUSED',
  PENDING: 'PENDING',
  PAID: 'PAID',
  DEPOSIT_PAID: 'DEPOSIT_PAID',
};

/** @type {import('types/Advice').AnswerOriginEnum} */
export const ADVICE_ANSWER_ORIGIN_ENUM = {
  BACK_OFFICE: 'BACK_OFFICE',
  FRONT_OFFICE: 'FRONT_OFFICE',
  SELF_OFFICE: 'SELF_OFFICE',
  INTEGRATION: 'INTEGRATION',
};
